"use client"

import { Suspense, useState } from "react"

import { CustomerAppointmentModal } from "./CustomerAppointmentModal"
import { useAppointmentBookingUrl } from "@/lib/hooks/use-appointment-booking-url"

function AppointmentBookingHostInner() {
  const [open, setOpen] = useState(false)
  const { handleOpenChange } = useAppointmentBookingUrl({ open, setOpen })

  return (
    <CustomerAppointmentModal
      open={open}
      onOpenChange={handleOpenChange}
      hideTrigger
    />
  )
}

export function AppointmentBookingHost() {
  return (
    <Suspense fallback={null}>
      <AppointmentBookingHostInner />
    </Suspense>
  )
}
